module.exports = __webpack_public_path__ + "bug-tracking-gradient-a263253db75e059d80c539626c75f480.webp";